// src/translations/translationWorks.js
// Translations for workConfig and codeConfig project content only

export const translationBlog = {
    en: {
        blog1_title: "What 15 years of live broadcast taught me about writing code",
    },

    it: {
        blog1_title: "What 15 years of live broadcast taught me about writing code",
    }
};
